// import React, { Component, useState } from 'react';
// import './index.css'
// import Home from './component/Home';
// import Category from './component/Category';
// import NavBar from './component/Nav';
// import Footer from './component/Footer';
// import DiscountApply from './component/Discount';
// import ProductList from './component/productdi';
// import ClientTable from './component/ClientTable';
// import Banner from './component/Banner';
// import Login from './component/Login';
// import Test from './component/Test';
// import Services from './component/Services';
// import Sellers from './component/Sellers';
// import SellersBuyersOrders from './component/SellersBuyersOrders';
// import BuyerOrders from './component/BuyerOrdes';
// import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
// import Buyers from './component/Buyers';
// import SellersProducts from './component/SellersProducts';
// import AdminPortals from './component/AdminPortals';
// import AdminUserTypes from './component/AdminUserTypes';
// import AdminUserTypeRights from './component/AdminUserTypeRights';
// import AdminUsers from './component/AdminUserCreation';
// import SystemConfig from './component/SystemConfig';
// import Feedback from './component/Feedback';
// import SellerserviceApprove from './component/SellerserviceApprove';
// import Query from './component/Query';
// import SRRRReport from './component/SRRRReport';
// import BuyerCommission from './component/BuyerCommission';
// import SellerPayments from './component/SellerPayment';
// import BankReports from './component/Reports/BankReports';
// import LogisticsReports from './component/Reports/LogisticsReports';
// import PaymentReports from './component/Reports/PaymentReports';
// import ReceiptReports from './component/Reports/ReceiptReports';
// import ServiceReports from './component/Reports/ServiceReports';
// import TdsReports from './component/Reports/TdsReports';
// import VendorReports from './component/Reports/VendorReports';
// import EmailTemplates from './component/emailTemplate';
// import Pincodes from './component/Pincodes';
// import UserRefeanceDetails from './component/UserRefeanceDetails';
// import GenerateInvoice from './component/GenerateInvoice';
// import GenerateReturnInvoice from './component/GenerateReturnInvoice';
// import SellerLogisticsOrders from './component/SellerLogisticsOrders';
// import Wallet from './component/Wallet';  
// import ChatBotQueries from './component/ChatBotQueries';
// import GenerateCommissionInvoice from './component/GenerateCommissionInvoice';
// import SideNav from './component/SideNav';

// const common = require('./utils/Common');
// const envConfig = require('./config/envConfig');

// const WithNavFoot = () => {
//   const [collapsed, setCollapsed] = useState(false);
  
//   return(
//     <>
//       <NavBar />
//       <SideNav collapsed={collapsed} setCollapsed={setCollapsed} />
//       <Outlet />
//       <Footer />
//     </>
//   );
// }

// const WithoutNavFoot = () => {
//   return(
//     <Outlet />
//   );
// }

// class App extends Component{
//   componentDidMount() {
//     if (envConfig.platform && (envConfig.platform == "production")) {
//       document.addEventListener('contextmenu', this.handleRightClick);
//       document.addEventListener('keydown', this.handleKeydown);
//     }
//   }

//   componentWillUnmount() {
//     if (envConfig.platform && (envConfig.platform == "production")) {
//       document.removeEventListener('contextmenu', this.handleRightClick);
//       document.removeEventListener('keydown', this.handleKeydown);
//     }
//   }

//   handleRightClick = (event) => {
//     event.preventDefault();
//   }

//   handleKeydown(event) {
//     if (event.ctrlKey && event.shiftKey && event.keyCode === 73) {
//       event.preventDefault();
//     }
//   }

//   render(){
//     return (
//       <BrowserRouter>
//         <Routes>
//           <Route element={<WithoutNavFoot />}>
//             <Route path='login' exact element={<Login/>}/>
//           </Route>
//           <Route element={<WithNavFoot />}>
//             <Route path='/' element={<Home/>}/>
//             <Route path='category' element={<Category/>}/>
//             <Route path='discount-apply' element={<DiscountApply/>}/>
//             <Route path='product-list' element={<ProductList/>}/>
//             <Route path='client-table' element={<ClientTable/>}/>
//             <Route path='cms' element={<Banner/>}/>
//             <Route path='test' element={<Test/>}/>
//             <Route path='service' element={<Services/>}/>
//             <Route path='sellers' element={<Sellers />} />
//             <Route path='buyers' element={<Buyers />} />
//             <Route path='sellers-buyers-orders' element={<SellersBuyersOrders />} />
//             <Route path='buyer-orders' element={<BuyerOrders />} />
//             <Route path='sellers-products' element={<SellersProducts />} />
//             <Route path='portals' element={<AdminPortals/>}/>
//             <Route path='user-types' element={<AdminUserTypes/>}/>
//             <Route path='user-type-rights/:user_type_id' element={<AdminUserTypeRights/>}/>
//             <Route path='admin-user-creation' element={<AdminUsers/>}/>
//             <Route path='system-config' element={<SystemConfig/>}/>
//             <Route path='user-feedback' element={<Feedback/>}/>
//             <Route path='user-query' element={<Query/>}/>
//             <Route path='seller-service-approve' element={<SellerserviceApprove/>}/>
//             <Route path='Srrr-report' element={<SRRRReport/>}/>
//             <Route path='buyer-commissions' element={<BuyerCommission/>}/>
//             <Route path='seller-payments' element={<SellerPayments/>}/>
//             <Route path='BankReports' element={<BankReports/>}/>
//             <Route path='LogisticsReports' element={<LogisticsReports/>}/>
//             <Route path='PaymentReports' element={<PaymentReports/>}/>
//             <Route path='ReceiptReports' element={<ReceiptReports/>}/>
//             <Route path='ServiceReports' element={<ServiceReports/>}/>
//             <Route path='TdsReports' element={<TdsReports/>}/>
//             <Route path='VendorReports' element={<VendorReports/>}/>
//             <Route path='email-templates' element={<EmailTemplates/>}/>
//             <Route path='pincodes' element={<Pincodes/>}/>
//             <Route path='user-refeance-details' element={<UserRefeanceDetails/>}/>
//             <Route path='generate-invoice' element={<GenerateInvoice/>}/>
//             <Route path="generate-commission-invoice" element={<GenerateCommissionInvoice/>}/>
//             <Route path='generate-return-invoice' element={<GenerateReturnInvoice/>}/>
//             <Route path='seller-logistics-orders' element={<SellerLogisticsOrders/>}/>
//             <Route path='wallet' element={<Wallet/>}/>
//             <Route path='chatbot-queries' element={<ChatBotQueries/>}/>
//           </Route>
//         </Routes>
//       </BrowserRouter>
//     )
//   }
// }

// export default App;

import React, { useState, useEffect } from 'react';
import './index.css'
import Home from './component/Home';
import Category from './component/Category';
import NavBar from './component/Nav';
import Footer from './component/Footer';
import DiscountApply from './component/Discount';
import ProductList from './component/productdi';
import ClientTable from './component/ClientTable';
import Banner from './component/Banner';
import Login from './component/Login';
import Test from './component/Test';
import Services from './component/Services';
import Sellers from './component/Sellers';
import SellersBuyersOrders from './component/SellersBuyersOrders';
import BuyerOrders from './component/BuyerOrdes';
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Buyers from './component/Buyers';
import SellersProducts from './component/SellersProducts';
import AdminPortals from './component/AdminPortals';
import AdminUserTypes from './component/AdminUserTypes';
import AdminUserTypeRights from './component/AdminUserTypeRights';
import AdminUsers from './component/AdminUserCreation';
import SystemConfig from './component/SystemConfig';
import Feedback from './component/Feedback';
import SellerserviceApprove from './component/SellerserviceApprove';
import Query from './component/Query';
import SRRRReport from './component/SRRRReport';
import BuyerCommission from './component/BuyerCommission';
import SellerPayments from './component/SellerPayment';
import BankReports from './component/Reports/BankReports';
import LogisticsReports from './component/Reports/LogisticsReports';
import PaymentReports from './component/Reports/PaymentReports';
import ReceiptReports from './component/Reports/ReceiptReports';
import ServiceReports from './component/Reports/ServiceReports';
import TdsReports from './component/Reports/TdsReports';
import VendorReports from './component/Reports/VendorReports';
import EmailTemplates from './component/emailTemplate';
import Pincodes from './component/Pincodes';
import UserRefeanceDetails from './component/UserRefeanceDetails';
import GenerateInvoice from './component/GenerateInvoice';
import GenerateReturnInvoice from './component/GenerateReturnInvoice';
import SellerLogisticsOrders from './component/SellerLogisticsOrders';
import Wallet from './component/Wallet';  
import ChatBotQueries from './component/ChatBotQueries';
import GenerateCommissionInvoice from './component/GenerateCommissionInvoice';
import SideNav from './component/SideNav';

const common = require('./utils/Common');
const envConfig = require('./config/envConfig');

const App = () => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (envConfig.platform && (envConfig.platform === "production")) {
      const handleRightClick = (event) => {
        event.preventDefault();
      };

      const handleKeydown = (event) => {
        if (event.ctrlKey && event.shiftKey && event.keyCode === 73) {
          event.preventDefault();
        }
      };

      document.addEventListener('contextmenu', handleRightClick);
      document.addEventListener('keydown', handleKeydown);

      return () => {
        document.removeEventListener('contextmenu', handleRightClick);
        document.removeEventListener('keydown', handleKeydown);
      };
    }
  }, []);

  const WithNavFoot = () => {
    return(
      <>
        <NavBar />
        <SideNav collapsed={collapsed} setCollapsed={setCollapsed} />
        <div className={`main-Home ${collapsed ? 'collapsed-content' : ''}`} style={{ marginLeft: collapsed ? '70px' : '250px', transition: '0.3s' }}>
          <Outlet />
        </div>
        <Footer />
      </>
    );
  };

  const WithoutNavFoot = () => {
    return(
      <Outlet />
    );
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<WithoutNavFoot />}>
          <Route path='login' exact element={<Login/>}/>
        </Route>
        <Route element={<WithNavFoot />}>
          <Route path='/' element={<Home/>}/>
          <Route path='category' element={<Category/>}/>
          <Route path='discount-apply' element={<DiscountApply/>}/>
          <Route path='product-list' element={<ProductList/>}/>
          <Route path='client-table' element={<ClientTable/>}/>
          <Route path='cms' element={<Banner/>}/>
          <Route path='test' element={<Test/>}/>
          <Route path='service' element={<Services/>}/>
          <Route path='sellers' element={<Sellers />} />
          <Route path='buyers' element={<Buyers />} />
          <Route path='sellers-buyers-orders' element={<SellersBuyersOrders />} />
          <Route path='buyer-orders' element={<BuyerOrders />} />
          <Route path='sellers-products' element={<SellersProducts />} />
          <Route path='portals' element={<AdminPortals/>}/>
          <Route path='user-types' element={<AdminUserTypes/>}/>
          <Route path='user-type-rights/:user_type_id' element={<AdminUserTypeRights/>}/>
          <Route path='admin-user-creation' element={<AdminUsers/>}/>
          <Route path='system-config' element={<SystemConfig/>}/>
          <Route path='user-feedback' element={<Feedback/>}/>
          <Route path='user-query' element={<Query/>}/>
          <Route path='seller-service-approve' element={<SellerserviceApprove/>}/>
          <Route path='Srrr-report' element={<SRRRReport/>}/>
          <Route path='buyer-commissions' element={<BuyerCommission/>}/>
          <Route path='seller-payments' element={<SellerPayments/>}/>
          <Route path='BankReports' element={<BankReports/>}/>
          <Route path='LogisticsReports' element={<LogisticsReports/>}/>
          <Route path='PaymentReports' element={<PaymentReports/>}/>
          <Route path='ReceiptReports' element={<ReceiptReports/>}/>
          <Route path='ServiceReports' element={<ServiceReports/>}/>
          <Route path='TdsReports' element={<TdsReports/>}/>
          <Route path='VendorReports' element={<VendorReports/>}/>
          <Route path='email-templates' element={<EmailTemplates/>}/>
          <Route path='pincodes' element={<Pincodes/>}/>
          <Route path='user-refeance-details' element={<UserRefeanceDetails/>}/>
          <Route path='generate-invoice' element={<GenerateInvoice/>}/>
          <Route path="generate-commission-invoice" element={<GenerateCommissionInvoice/>}/>
          <Route path='generate-return-invoice' element={<GenerateReturnInvoice/>}/>
          <Route path='seller-logistics-orders' element={<SellerLogisticsOrders/>}/>
          <Route path='wallet' element={<Wallet/>}/>
          <Route path='chatbot-queries' element={<ChatBotQueries/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;